const DYNAMO_DB_VERB = false;
const ROLES_VERB = false;
const EXPRESS_VERB = false;
const RETRY_VERB = false;

export { DYNAMO_DB_VERB, ROLES_VERB, EXPRESS_VERB, RETRY_VERB };
